/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\VOLVO.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:25:30 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function VOLVO(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M735.55,507.13c-19.45,0-35.28,11.91-35.28,26.55s15.83,26.55,35.28,26.55,36.04-11.91,36.04-26.55-16.16-26.55-36.04-26.55Zm0,44.48c-6.87,0-12.09-7.7-12.09-17.91,0-10.84,5.1-18.67,12.09-18.67s12.11,8.35,12.09,18.67c-.04,9.69-5.55,17.91-12.09,17.91Zm-267.17-44.48c-19.45,0-35.3,11.91-35.3,26.55s15.85,26.55,35.3,26.55,36.04-11.91,36.04-26.55-16.16-26.55-36.04-26.55Zm0,44.48c-6.9,0-12.09-7.7-12.09-17.91,0-10.84,5.08-18.67,12.09-18.67s12.11,8.35,12.09,18.67c0,9.69-5.55,17.91-12.09,17.91Zm188.84-35.44h8.75l-15.34,29.89-17.51-29.89h12.4v-6.56h-49.59v6.56h11.66l22.59,42.29h27l22.61-42.29h11.64v-6.56h-34.23v6.56Zm-270.06,.63h8.95l-14.98,27.96-16.37-27.96h11.95v-7.86h-50.86v7.79h11.91l22.39,41.98,.16,.31h27.72l.18-.31,22.39-41.98h11.91v-7.79h-35.35v7.86Zm7.54-.63h0Zm-13.32,29.6l6.29-11.75-6.18,11.93-.11-.18Zm-11.51-18.92l-6.2-10.28h.18l6.02,10.28Zm200.66,23.6h-12.42v-34.27h11.69v-6.56h-45.96v6.56h11.69v34.27h-11.69v8.01h69.29v-22.66h-7.28c-.35,8.2-7.11,14.66-15.31,14.64Zm173.59-236.07l-30.11,30.18c15.01,12.54,28.53,26.76,40.3,42.38l30.29-30.22,12.81-12.81c13.3,16.1,24.94,33.49,34.77,51.92h7.77v-137.32h-137.12v7.77c19,10.15,36.91,22.23,53.44,36.04l-12.13,12.07Z"/>
            <path d="M798.35,375.61l-30.78,30.78c73.96,119.84,36.76,276.95-83.08,350.91-119.84,73.96-276.95,36.76-350.91-83.08-73.96-119.84-36.76-276.95,83.08-350.91,85.46-52.74,193.92-50.41,277.03,5.96l30.51-30.54c-133.37-95.8-319.14-65.34-414.94,68.03-95.8,133.37-65.34,319.14,68.03,414.94,133.37,95.8,319.14,65.34,414.94-68.03,72.15-100.45,74.58-235.07,6.11-338.06Z"/>
        </svg>
    );
}

export default VOLVO;
